module.exports = __webpack_public_path__ + "static/img/0000趣拍拍2.be0c42c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/0000趣拍拍2.jpg
// module id = /swV
// module chunks = 0